import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';

const cardStyle = {
  background: 'rgba(10, 14, 39, 0.6)',
  border: '1px solid rgba(0, 212, 255, 0.25)',
  borderRadius: 12,
  padding: 24,
  marginBottom: 24,
  maxWidth: 480,
};
const labelStyle = { display: 'block', color: '#B0BEC5', marginBottom: 8, fontSize: 14 };
const inputStyle = {
  width: '100%',
  maxWidth: 200,
  padding: '10px 14px',
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(0, 212, 255, 0.3)',
  borderRadius: 8,
  color: '#fff',
  fontSize: 16,
};
const buttonStyle = {
  marginTop: 16,
  padding: '12px 24px',
  background: 'linear-gradient(135deg, #B026FF 0%, #0066FF 100%)',
  border: '1px solid rgba(0, 212, 255, 0.5)',
  borderRadius: 8,
  color: '#fff',
  fontSize: 15,
  fontWeight: 600,
  cursor: 'pointer',
};

const BotPayment = () => {
  const [accessAmountCents, setAccessAmountCents] = useState(50000);
  const [initialCredits, setInitialCredits] = useState(50);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/settings/bot-payment`)
      .then((res) => {
        setAccessAmountCents(res.data.accessAmountCents ?? 50000);
        setInitialCredits(res.data.initialCredits ?? 50);
      })
      .catch((err) => {
        if (err.response?.status === 403) {
          setMessage({ type: 'error', text: 'Acesso restrito ao administrador da Tilti.' });
        } else {
          setMessage({ type: 'error', text: 'Erro ao carregar configuração.' });
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = () => {
    const cents = Math.round(Number(accessAmountCents));
    const credits = Math.round(Number(initialCredits));
    if (cents < 0 || isNaN(cents)) {
      setMessage({ type: 'error', text: 'Valor (R$) inválido.' });
      return;
    }
    if (credits < 0 || isNaN(credits)) {
      setMessage({ type: 'error', text: 'Créditos inválidos.' });
      return;
    }
    setMessage({ type: '', text: '' });
    setSaving(true);
    axios
      .put(`${API_BASE}/api/settings/bot-payment`, {
        accessAmountCents: cents,
        initialCredits: credits,
      })
      .then(() => {
        setMessage({ type: 'success', text: 'Configuração salva. O novo valor e créditos passam a valer para o próximo cliente.' });
      })
      .catch((err) => {
        setMessage({ type: 'error', text: err.response?.data?.error || 'Erro ao salvar.' });
      })
      .finally(() => setSaving(false));
  };

  const valueReais = Number(accessAmountCents) / 100;

  if (loading) {
    return (
      <div style={cardStyle}>
        <p style={{ color: '#B0BEC5' }}>Carregando...</p>
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginBottom: 16, color: '#e0e0e0' }}>Pagamento do BOT</h2>
      <p style={{ color: '#B0BEC5', marginBottom: 24, maxWidth: 560 }}>
        Valor cobrado no checkout para um novo cliente se tornar cliente e quantidade de créditos iniciais que ele recebe.
        Você pode fazer promoções (ex.: R$ 500 e 60 créditos = cliente paga 500 e ganha 10 créditos a mais).
      </p>
      <div style={cardStyle}>
        <label style={labelStyle}>Valor de acesso (R$)</label>
        <input
          type="number"
          min="0"
          step="0.01"
          value={valueReais}
          onChange={(e) => {
            const v = parseFloat(e.target.value);
            if (!isNaN(v) && v >= 0) setAccessAmountCents(Math.round(v * 100));
          }}
          style={inputStyle}
        />
        <label style={{ ...labelStyle, marginTop: 16 }}>Créditos iniciais</label>
        <input
          type="number"
          min="0"
          step="1"
          value={initialCredits}
          onChange={(e) => {
            const v = parseInt(e.target.value, 10);
            if (!isNaN(v) && v >= 0) setInitialCredits(v);
          }}
          style={inputStyle}
        />
        <button type="button" onClick={handleSave} disabled={saving} style={buttonStyle}>
          {saving ? 'Salvando...' : 'Salvar'}
        </button>
        {message.text && (
          <p style={{ marginTop: 16, color: message.type === 'error' ? '#ff6b6b' : '#4ade80', fontSize: 14 }}>
            {message.text}
          </p>
        )}
      </div>
    </div>
  );
};

export default BotPayment;
